/** Matches legacy `buxusweb` `Login/index.validation.ts` phone rules (practical, not strict E.164). */

export const LEGACY_PHONE_FORMAT_REGEX = /^[\d\s\-().+]+$/;

export const LEGACY_PHONE_INVALID_MESSAGE =
  "Please enter a valid phone number (at least 10 digits).";

export function legacyPhoneDigitCount(value: string): number {
  return value.replace(/\D/g, "").length;
}

/** True when non-empty, allowed characters, and ≥10 digits (US-style minimum). */
export function isLegacyPracticalPhone(value: string): boolean {
  const s = value.trim();
  if (!s) return false;
  if (!LEGACY_PHONE_FORMAT_REGEX.test(s)) return false;
  return legacyPhoneDigitCount(s) >= 10;
}

/** US display helper: (512) 555-1212 for up to 10 digits; leaves partial segments while typing. */
export function formatUsPhoneTyping(value: string): string {
  const d = value.replace(/\D/g, "").slice(0, 10);
  if (d.length === 0) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
